import { render, staticRenderFns } from "./recipes-list-page.vue?vue&type=template&id=4befe7ba&scoped=true"
import script from "./recipes-list-page.vue?vue&type=script&lang=js"
export * from "./recipes-list-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befe7ba",
  null
  
)

export default component.exports